export default class KeyboardInputController {
  inputState = {
    up: false,
    down: false,
    left: false,
    right: false,
    confirm: false
  };

  handleKeyChange = (e) => {
    switch (e.key) {
      case "ArrowUp":
        this.inputState.up = e.type === "keydown";
        break;
      case "ArrowDown":
        this.inputState.down = e.type === "keydown";
        break;
      case "ArrowLeft":
        this.inputState.left = e.type === "keydown";
        break;
      case "ArrowRight":
        this.inputState.right = e.type === "keydown";
        break;
      case "Enter":
        this.inputState.confirm = e.type === "keydown";
        break;
      default:
        break;
    }
  };

  plugin() {
    document.addEventListener("keydown", this.handleKeyChange, false);
    document.addEventListener("keyup", this.handleKeyChange, false);
  }

  getInputState() {
    return this.inputState;
  }
}
